import React from 'react';
import { Button } from 'antd';
import cn from 'classnames';
import styles from './CardPagination.module.scss';

const CardPagination = ({
  onPrevClick,
  onNextClick,
  currentPage,
  maxPage,
  className,
}) => {
  return (
    <div className={cn(styles.root, className)}>
      <Button className={styles.navigation} icon="left" onClick={onPrevClick} />
      {currentPage || 1}/{maxPage || 1}
      <Button
        className={styles.navigation}
        icon="right"
        onClick={onNextClick}
      />
    </div>
  );
};

export default CardPagination;
